import { researchedMediaSettingOptions } from 'src/constants';
import styles from './ResearcherSection.module.scss';
import { SettingsSwitchItem } from 'src/v2/components/SettingsSwitchItem';

export const ResearcherSection = () => {
  return (
    <div className={styles.root}>
      <p className={styles.caption}>Display other related resources</p>

      <div className={styles.options}>
        {researchedMediaSettingOptions.map(
          ({ value, label, icon, settingKey }) => (
            <SettingsSwitchItem
              key={value}
              value={value}
              label={label}
              icon={icon}
              settingKey={settingKey}
            />
          ),
        )}
      </div>
    </div>
  );
};
